import { marked } from 'marked';

// Configure once at module load; ESM modules are singletons
marked.setOptions({ breaks: true, gfm: true });

export { marked };
